import observeResize from '../../../util/resizeObserver';

const MARGIN_OF_ERROR = 10;
const MAX_RESIZE_OBS_WINDOW = 3000;

// jw: let's try to chase the element for at most 3 seconds. This matches the resize observation
//     window above.
const ELEMENT_CHASING_ATTEMPTS = 6;
const ELEMENT_CHASING_DELAY = 500;

// jw: globally scope these variables to allow all instances of this mixin to share these values.
let scrollingToElement = null;
let resizeObserver = null;

export default {
  data() {
    return {
      $_tabsParentId: 'pdpTabsParent',
      $_scrollTimeoutId: null,
    };
  },
  methods: {
    $_scrollToElementWhenResized(container, element) {
      // jw: guard against non-existent elements.
      if (!container || !element) {
        return;
      }

      // jw: make sure we clear out any resize observer already present.
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }

      // jw: setup a resize observer on the container
      resizeObserver = observeResize(container, () => this.$_scrollToElement(element));

      // jw: finally, we need to make sure to disconnect the resize observer after a timeout.
      setTimeout(() => {
        if (resizeObserver) {
          resizeObserver.disconnect();
          resizeObserver = null;
        }
      }, MAX_RESIZE_OBS_WINDOW);
    },
    $_scrollToElement(element, attempts = 0, providedTop = null) {
      // jw: before we do anything let's see if we are already scrolling to the element
      if (scrollingToElement === element) {
        return;
      }

      clearTimeout(this.$_scrollTimeoutId);

      if (!element || attempts >= ELEMENT_CHASING_ATTEMPTS) {
        return;
      }

      scrollingToElement = element;
      const top = providedTop || this.$_calculateTop(element);

      // an: Using setTimeout as a workaround to scroll only after the hash has been set
      // Guess browser waits for the event 'hashchange_event' to be completed
      // https://developer.mozilla.org/en-US/docs/Web/API/Window/hashchange_event
      if ('scrollBehavior' in document.documentElement.style) {
        setTimeout(() => window.scrollTo({ top, behavior: 'smooth' }));
      } else {
        setTimeout(() => window.scrollTo(0, top));
      }

      // jw: let's add a timeout to try to chase the element in case the act of scrolling
      //     causes vue components to render and shift the elements position from where
      //     it was when we started.
      this.$_scrollTimeoutId = setTimeout(() => {
        // jw: it is vital that we clear the scrollingToElement here. Otherwise the scroll
        //     will short out above and nothing will happen.
        scrollingToElement = null;

        const newTop = this.$_calculateTop(element);
        const topOffsetDifference = top - newTop;

        if (Math.abs(topOffsetDifference) <= MARGIN_OF_ERROR) {
          return;
        }

        this.$_scrollToElement(element, attempts + 1, newTop);
      }, ELEMENT_CHASING_DELAY);
    },
    $_calculateTop(element) {
      const currentScrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
      let top = element.getBoundingClientRect().top + window.pageYOffset;

      // an: The nav is sticky only when scrolling up
      // so we need to account for that in these calculations
      if (top < currentScrollPosition) {
        top -= document.querySelector('header > nav').offsetHeight;
      }

      // Take into account the tabs Height (sticky)
      top -= document.getElementById(this.$data.$_tabsParentId).offsetHeight;

      // space to breath between Tab section and the top of the section
      const scrollGap = 15;
      top -= scrollGap;

      return top;
    },
  },
};
